import { handleActions } from 'redux-actions';

import * as actions from './actions';

const initialState = null;

const options = { prefix: 'Volunteers' };

const reducer = handleActions(
  {
    [actions.set]: {
      next(state, { payload }) {
        return { ...payload, _lastUpdated: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
    [actions.remove]: {
      next(state, { payload }) {
        return { ...state, ...payload, _lastUpdate: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
    [actions.addNote]: {
      next(state, { payload }) {
        return { ...state, ...payload, _lastUpdate: Date.now() };
      },
      throw(state) {
        return state;
      },
    },
  },
  initialState,
  options
);

export default reducer;
